import React, { useState } from 'react'
import './Home.css'
import { Link } from 'react-router-dom'
import {BsArrowRight} from 'react-icons/bs'
import HomeProducts from '../HomeProducts/HomeProducts'
import {AiOutlineShoppingCart} from 'react-icons/ai'
import {AiOutlineHeart, AiOutlineCloseCircle} from 'react-icons/ai'
import {BsEye} from 'react-icons/bs'
import { useAuth0 } from "@auth0/auth0-react"


const Home = ({detail, view, close, setClose, addtocart}) => {
     const { loginWithRedirect,isAuthenticated } = useAuth0();
     const [homeProducts] = useState(HomeProducts)
  return (
     <>
     {
        close?
        <div className='product_detail'>
        <div className='container'>
            <button onClick={()=> setClose(false)} className='closebtn'><AiOutlineCloseCircle/></button>
            {
                detail.map((curElm)=>{
                  return(
                    <div className='productbox'>
                        <div className='imgbox'>
                            <img src={curElm.Img} alt={curElm.Cat}/>

                        </div>
                        <div className='detail'>
                            <h4>{curElm.Cat}</h4>
                            <p>More than just a brand</p>
                            <h3>{curElm.Price}</h3>
                            <button>Add To Cart</button>

                        </div>

                    </div>
                  )
                })
            }

        </div>

    </div> : null
    }
           <div className='home_container'>
                <div className='header'>
                     <h2>Affordable fashion clothing</h2>
                </div>
          
               <div className='detail'>
                     <div className='clothing'>
                          <div className='career'>
                               <h3>Career fashion</h3>
                               <p>Shop for blazers,suits,career dresses and other <br/> business formal apparel at affordable prices.</p>
                          </div>

                          <div className='everyday'>
                               <h3>Everyday fashion</h3>
                               <p>Find great deals on jeans,sweatpants,T-shirts <br/> and other casual fashions.</p>
                          </div>

                         <div className='accessories'>
                                <h3>Fashionable accessories</h3>
                                <p>Shop for contemporary fashion accessories.</p>
                         </div>
                        <Link to='/shop' className='link'>Shop Now <BsArrowRight/> </Link>
                     </div>   
                </div>
       
          </div>
          <div className='about'>
               <div className='container'>
                    <div className='box'>
                         
                         <div className='detail'>
          
                              <p>Welcome to <span>Top Fashion</span>, where fashion meets creativity and self-expression. We are more than just a brand; 
                                 we're a community of fashion enthusiasts who believe in the power of style to empower and inspire.
                                 We are a local shop with world-class fashion flair. We invite you to join us on this fashion adventure. 
                                 Explore our collections, discover your unique style, and be a part of the <span>Top Fashion</span> family.
                              </p>
                             <Link to='/about'> <button>Learn More</button></Link>
                         </div>

                         <div className='model_img'>
                              <img src="./img/lady.jpg" alt="model"/>
                         </div>
                    
                    </div>
                   
               </div>
          </div>
          <div className='product'> 
               <h2>Top Products</h2>
               <div className='container'>
                    {
                         homeProducts.map((curElm) => {
                                    return(
                                        <div className='product_box' key={curElm.id}>
                                              <div className='img_box'>
                                                   <img src={curElm.Img} alt={curElm.Cat} />
                                                   <div className='icons'>
                                                       {
                                                            isAuthenticated?
                                                            <li onClick={() => addtocart(curElm)}><AiOutlineShoppingCart/></li>
                                                                :
                                                            <li onClick={() => loginWithRedirect()}><AiOutlineShoppingCart/></li>
                                                       }
                                                      
                                                       <li><AiOutlineHeart/></li>
                                                       <li onClick={()=>view(curElm)}><BsEye/></li>
                                                      
                                                   </div>
                                              </div>
                                              <div className='detail'>
                                                 <p>{curElm.Cat}</p>
                                                 <h3>{curElm.Price}</h3>
                                              </div>
                                        </div>
                                    )
                         })
                    }
                    

                    
               </div>
          </div>
     </>
  )
}

export default Home